/* Copyright 2011-2014 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/aspect",
    "./_DescriptionMixin",
    "mw-event-utils/platformize"
], function (declare, aspect, _DescriptionMixin, platformize) {
    return declare([_DescriptionMixin], {
        /** @lends _TooltipMixin# */

        /**
         * It should be mixed in by any component that wants a tooltip to be attached to it.
         * @class
         */

        _updateDescription: function () {
            this.inherited(arguments);
            this._updateTooltip();
        },

        _setTextAttr: function () {
            this.inherited(arguments);
            this._updateTooltip();
        },

        _setShortcutAttr: function (value) {
            this._set("shortcut", value);
            this._updateTooltip();
        },

        _updateTooltip: function () {
            var tooltipLabel = "",
                tooltipShortcut = "",
                tooltipDescription = "",
                firstBuffer = "",
                secondBuffer = "";

            if (this.textOverride) {
                tooltipLabel = this.textOverride.replace(/\n/g, " ");
            } else if (this.text) {
                tooltipLabel = this.text.replace(/\n/g, " ");
            }

            if (this.shortcut) {
                tooltipShortcut = this._getPlatformSpecificShortcutString();
            }

            if (this.descriptionOverride) {
                tooltipDescription = this.descriptionOverride;
            } else if (this.description) {
                tooltipDescription = this.description;
            }

            // To maintain backward consistency, we flip the order of description
            // and shortcut if they are the only two parts of the tooltip.
            if (!tooltipLabel && tooltipShortcut && tooltipDescription) {
                tooltipLabel = tooltipDescription;
                tooltipDescription = "";
                firstBuffer = " ";
            } else if (tooltipLabel) {
                if (tooltipShortcut) {
                    firstBuffer = " ";
                }
                if (tooltipDescription) {
                    secondBuffer = " - ";
                }
            }

            this.domNode.setAttribute("title", tooltipLabel + firstBuffer + tooltipShortcut + secondBuffer + tooltipDescription);
        },

        _getPlatformSpecificShortcutString: function () {
            return "(" + platformize.getPlatformSpecificString(this.shortcut) + ")";
        }
    });
});

